/* eslint-disable @typescript-eslint/consistent-type-assertions */
import type { CustomFieldResource } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { useMemo } from "react";
import { CustomFieldMultiSelect } from "~/components/MultiSelect/CustomFieldMultiSelect";
import type FormFieldProps from "~/components/form/FormFieldProps";
import { Select } from "~/primitiveComponents/form/Select/Select";
import Text from "~/primitiveComponents/form/Text/Text";
interface CustomFieldSelectProps extends FormFieldProps<string[]> {
    customField: CustomFieldResource;
    disabled?: boolean;
    autoFocus?: boolean;
    error?: string;
    warning?: string;
}
export const CustomFieldSelect: React.FC<CustomFieldSelectProps> = ({ customField, value, onChange, disabled, autoFocus, error, warning, ...rest }) => {
    const customFieldItems = useMemo(() => {
        if (!customField.Values || customField.Values.length === 0) {
            return [];
        }
        return customField.Values.sort((a, b) => a.SortOrder - b.SortOrder).map((customFieldValue) => ({
            value: customFieldValue.Id,
            text: customFieldValue.Name,
            description: customFieldValue.Description,
            color: customFieldValue.Color,
        }));
    }, [customField.Values]);
    switch (customField.Type) {
        case "SingleSelect":
            return (<Select items={customFieldItems.map((item) => ({
                    value: item.value,
                    text: item.text,
                    description: item.description,
                }))} value={value[0] as string} onChange={(newValue) => onChange?.([newValue] as string[])} disabled={disabled} allowFilter={true} allowClear={true} autoFocus={autoFocus} label={`${customField.Name} (Single Select)`} error={error} warning={warning} {...rest}/>);
        case "MultiSelect":
            return <CustomFieldMultiSelect customField={customField} value={value as string[]} onChange={onChange} disabled={disabled} autoFocus={autoFocus} {...rest}/>;
        case "FreeText":
        default:
            return <Text value={value[0]} onChange={(newValue) => onChange?.([newValue])} label={`${customField.Name} (Free Text)`} disabled={disabled} autoFocus={autoFocus} error={error} warning={warning} {...rest}/>;
    }
};
CustomFieldSelect.displayName = "CustomFieldSelect"
export default CustomFieldSelect;
